import {configureStore} from '@reduxjs/toolkit';

import {academyApi} from './api/academyApi';

export const store = configureStore({
  reducer: {
    [academyApi.reducerPath]: academyApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([academyApi.middleware]),
});
